import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Heart, Package, ShieldCheck, Sparkles, ArrowRight } from "lucide-react";
import { UI_EXTRA } from "@/data/uiExtra";

// Quick access to the pilgrim's favourite travel packages.
export function FavoritePackages({ tc, favPackages }) {
  if (!favPackages.length) return null;
  return (
      <Card className="rounded-3xl border-border/50 shadow-sm p-6" data-testid="dashboard-favorites">
        <div className="flex items-center gap-2 mb-4">
          <Heart className="h-5 w-5 text-rose-500 fill-rose-500" />
          <div>
            <p className="font-medium">{tc(UI_EXTRA["dash.favTitle"])}</p>
            <p className="text-xs text-muted-foreground">{tc(UI_EXTRA["dash.favHint"])}</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {favPackages.map((p) => (
            <Link key={p.id} to="/packages" data-testid={`dashboard-fav-${p.id}`}>
              <motion.div whileHover={{ y: -2 }}>
                <Card className="rounded-2xl border-border/50 p-4 h-full flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><Package className="h-5 w-5" /></span>
                  <div className="min-w-0 flex-1">
                    <p className="font-medium text-sm truncate">{tc(p.name)}</p>
                    <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                      <span className="text-xs text-muted-foreground">{p.type === "hajj" ? tc(UI_EXTRA["pkg.hajj"]) : tc(UI_EXTRA["pkg.umrah"])}</span>
                      {p.license_no && <span className="inline-flex items-center gap-0.5 text-[10px] text-emerald-600 dark:text-emerald-400"><ShieldCheck className="h-3 w-3" /> {tc(UI_EXTRA["pkg.verified"])}</span>}
                      {p.promo && <span className="inline-flex items-center gap-0.5 text-[10px] text-rose-500"><Sparkles className="h-3 w-3" /> {p.promo_label || tc(UI_EXTRA["pkg.promo"])}</span>}
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground shrink-0 rtl:-scale-x-100" />
                </Card>
              </motion.div>
            </Link>
          ))}
        </div>
      </Card>
  );
}
